var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var EyeOff = function EyeOff(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M11.29 12.71a.953.953 0 0 1-.02-.021l.04.04a.951.951 0 0 1-.02-.02Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.707 2.293a1 1 0 0 0-1.414 1.414l2.834 2.834c-1.49 1.236-2.817 2.902-3.995 4.963a1 1 0 0 0 0 .992C3.907 17.353 7.52 20 12 20a10.32 10.32 0 0 0 5.206-1.38l3.087 3.087a1 1 0 0 0 1.414-1.414l-3.572-3.572a1.012 1.012 0 0 0-.072-.08l-2.45-2.443L3.707 2.293Zm5.585 8.413 4.002 4.002a3 3 0 0 1-4.002-4.002Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      d: "M9.088 4.404A10.466 10.466 0 0 1 12.002 4c4.479 0 8.091 2.648 10.866 7.504a1 1 0 0 1 0 .992c-.808 1.414-1.685 2.641-2.637 3.67a1.006 1.006 0 0 1-.194.164L8.526 4.818a1 1 0 0 1 .562-.414Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default EyeOff;